import Vue from "vue";
import Vuex from "vuex";
import axios from "../../../api";
Vue.use(Vuex);
// 设置允许跨域携带cookie
// axios.defaults.withCredentials = true;
var getList = function () {
  axios.get(`api/cms/column?id=1,2,3`).then((res) => {
    if (res.data.code === 0) {
      state.index.tableOriginal = res.data.data;
      state.index.tableDataAll = processingTree(res.data.data, null);
      processingMenu(res.data.data);
      // state.index.id = res.data.data[0].id;
      processingTable(state.index.id);
      console.log(state.index.tableData);
      docunmentNumber(state.index.tableData);
    }
  });
};
var processingMenu = function (data) {
  // 处理菜单树形
  state.index.menu = [];
  data.forEach((item) => {
    if (!item.parent_id) {
      let obj = {
        name: item.column_name,
        id: item.id,
        flag: item.id === state.index.id,
      };
      state.index.menu.push(obj);
    }
  });
};
var processingTable = function (id) {
  state.index.menuOne = [];
  state.index.id = id;
  processingMenu(state.index.tableOriginal);
  state.index.tableDataAll.forEach((item) => {
    if (item.id === id) {
      state.index.menuOne.push(item);
      if (item.children && item.children.length > 0) {
        state.index.tableData = item.children;
      } else {
        state.index.tableData = [];
      }
    }
  });
};
var processingTree = function (data, pid) {
  // 处理表格树形
  var result = [];
  var temp;
  for (var i in data) {
    data[i].flag = false;
    if (data[i].parent_id === pid) {
      result.push(data[i]);
      temp = processingTree(data, data[i].id);
      if (temp.length > 0) {
        data[i].children = temp;
      }
    }
  }
  return result;
};
var docunmentNumber = function (data) {
  // 修改文档数量
  let temp;
  data.forEach((item) => {
    if (item.children && item.children.length > 0) {
      for (var i = 0; i < item.children.length; i++) {
        item.count += item.children[i].count;
        if (item.children[i].children && item.children[i].children.length > 0) {
          temp = docunmentNumber(item.children[i].children);
          if (temp.length > 0) {
            temp.forEach((data) => {
              item.count += data.count;
              item.children[i].count += data.count;
            });
          }
        }
      }
    }
  });
  return data;
};
var getArticleList = function () {
  let ids = getIds(state.articleColumn);
  ids = ids.substr(0, ids.length - 1);
  axios
    .get(
      `/api/cms/article?size=${state.article.size}&page=${state.article.index}&id=${ids}`
    )
    .then((res) => {
      if (res.data.code === 0) {
        state.article.articleList = subordinateColumn(res.data.data.list);
        state.article.total = res.data.data.total;
      }
    });
};
var getAllArticleList = function () {
  // 获取所有的文档
  axios
    .post(`/api/cms/getAllCheckedArticle`, {
      size: 1000,
      page: 1,
    })
    .then((res) => {
      if (res.data.code === 0) {
        state.allArticle.allArticleList = subordinateColumn(res.data.data.rows);
      }
    });
};
var getIds = function (data) {
  let ids = "";
  let temp = "";
  data.forEach((item) => {
    ids += item.id + ",";
    if (item.children && item.children.length > 0) {
      temp = getIds(item.children);
    }
    if (temp) {
      ids += temp;
    }
  });
  return ids;
};
var subordinateColumn = function (data) {
  data.forEach((i) => {
    i.article_create = timeChange(i.article_create);
    state.index.tableOriginal.forEach((item) => {
      if (i.column_id === item.id) {
        i.article_column = item.column_name;
      }
    });
  });
  return data;
};
var timeChange = function (time) {
  // 处理日期格式
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return (
    year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
  );
};

// 处理pass
var getPassList = function (id, idList = [], isAdmin) {
  axios.get(`api/cms/column?id=${id}`).then((res) => {
    if (res.data.code === 0) {
      state.pass.menuOriginal = [];
      res.data.data.forEach((item) => {
        state.pass.menuOriginal.push({ ...item }); // 平级菜单所有数据
      });
      state.pass.tableOriginal = res.data.data;
      let parentId = [],
        menus = [];
      if (isAdmin) {
        // 如果是管理员获取所有权限
        idList = getAdminIdList(res.data.data);
      }
      if (idList.length) {
        parentId = getParentId(res.data.data, idList);
        menus = dealMenuAuth(res.data.data, parentId, idList);
      }

      state.pass.tableDataAll = passTree(menus, null);
      // 过滤树形结构
      passTable(state.pass.id);
    }
  });
};

// 获取管理员的所有权限
const getAdminIdList = function (data) {
  let level1ParentIds = [],
    level2ParentIds = [],
    level3ParentIds = []; // 获取一级权限所有父级ids
  let ids = [];
  data.forEach((item) => {
    if (!item.parent_id) {
      level1ParentIds.push(item.id);
    }
  });
  data.forEach((item) => {
    if (level1ParentIds.includes(item.parent_id)) {
      level2ParentIds.push(item.id);
    }
  });
  data.forEach((item) => {
    if (level2ParentIds.includes(item.parent_id)) {
      level3ParentIds.push(item.id);
    }
  });
  data.forEach((item) => {
    if (level3ParentIds.includes(item.parent_id)) {
      ids.push(item.id + "");
    }
  });
  return ids;
};

// 获取roleId父级id ，通过已有权限的菜单找到他们的父级菜单id的集合
const getParentId = function (data, idList) {
  const ids = [];
  idList.forEach((element) => {
    for (let i = 0, len = data.length; i < len; i++) {
      if (
        parseInt(element) === data[i].id &&
        !ids.includes(data[i].parent_id)
      ) {
        ids.push(data[i].parent_id);
        break;
      }
    }
  });
  return ids;
};

// 根据父级id 去处理菜单数组 过滤没有权限的菜单
const dealMenuAuth = function (data, parent, son) {
  const result = [];
  data.forEach((element) => {
    if (!element.parent_id || element.parent_id === 3) {
      result.push(element);
    } else if (
      parent.includes(element.id) ||
      son.includes(element.id.toString()) ||
      son.includes(element.parent_id.toString())
    ) {
      result.push(element);
    }
  });
  return result;
};

// 获取子菜单下文章
export const getArticlesOfSubMenu = (id) => {
  return axios.get(`api/cms/column?id=${id}&showArticle=true`);
};

var passTable = function (id) {
  state.pass.menuOne = [];
  state.pass.id = id;
  state.pass.tableDataAll.forEach((item) => {
    if (item.id === id) {
      state.pass.menuOne.push(item);
      if (item.child && item.child.length > 0) {
        state.pass.tableData = item.child;
      } else {
        state.pass.tableData = [];
      }
    }
  });
};
var passTree = function (data, pid) {
  // 处理表格树形
  var result = [];
  var temp;
  for (var i in data) {
    if (data[i].parent_id === pid) {
      data[i].isDir = true;
      result.push(data[i]);
      data[i].children = [];
      temp = passTree(data, data[i].id);
      if (temp.length > 0) {
        temp.sort((a, b) => {
          return b.column_power - a.column_power;
        });
        data[i].child = temp;
      }
      setTreeMap(data[i]);
    }
  }
  return result;
};

var setTreeMap = function (treeNode) {
  if (!Reflect.has(state.pass.mapOfSideMenu, treeNode.column_id)) {
    state.pass.mapOfSideMenu[treeNode.column_id] = treeNode;
  }
};
// 3.存储的公共的数据
const state = {
  loginInfo: {
    userData: {},
    isLogin: false,
  },
  ids: "",
  info: {},
  index: {
    menu: [],
    tableOriginal: [],
    tableDataAll: [],
    tableData: [],
    menuOne: [],
    id: 1,
    getList: getList,
  },
  article: {
    size: 30,
    index: 1,
    total: 0,
    articleList: [],
    getArticleList: getArticleList,
    articleOption: {},
  },
  allArticle: {
    allArticleList: [],
    getAllArticleList: getAllArticleList,
  },
  pass: {
    menuOne: [],
    id: 1,
    menuOriginal: [],
    tableOriginal: [],
    tableDataAll: [],
    tableData: [],
    columnsMap: {}, // column_id:id
    mapOfSideMenu: {},
    getPassList: getPassList,
  },
  articleColumn: [],
  articleColumn2: [],
  articleOne: {},
  addflag: false,
  editflag: false,
  addOrOptionEditor: false,
};
// 4.修改state中数据的方法
const mutations = {
  setLoginInfo(state, payload) {
    console.log(payload);
    state.loginInfo.userData = payload.userData;
    state.loginInfo.isLogin = payload.isLogin;
  },
  setIds(state, id) {
    state.ids = id;
  },
  upTable(state, id) {
    processingTable(id);
  },
  upMenuOne(state, data) {
    state.index.menuOne = [data];
  },
  setArticleColumn(state, data) {
    state.articleColumn = [data];
  },
  setArticleColumn2(state, data) {
    state.articleColumn2 = [data];
  },
  setArticleOne(state, data) {
    state.articleOne = data;
  },
  setAdd(state, data) {
    state.addflag = data;
  },
  setEdit(state, data) {
    state.editflag = data;
  },
  setSize(state, data) {
    state.article.size = data;
  },
  setIndex(state, data) {
    state.article.index = data;
  },
  setArticleOption(state, data) {
    state.article.articleOption = data;
  },
  setInfo(state, data) {
    state.info = data;
  },
  addOrOptionEditor(state, data) {
    state.addOrOptionEditor = data;
  },
};
// 5.创建一个vuex的实例 。并暴露出去
export default new Vuex.Store({
  state, // state:state
  mutations,
});
